<!-- <div class="login-page">
  <div class="container d-flex align-items-center">
    <div class="form-holder has-shadow">
      <div class="row">
        <div class="col-lg-6">
          <div class="info d-flex align-items-center blue-bg">
            <div class="content">
              <div class="logo">
                <img src="assets/images/logo2.png" width="100%" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 bg-white">
          <div class="form d-flex align-items-center">
            <div class="content">
              <h6>Don't forget to check your Spam/Junk folder for your verification email.</h6>
              <small>Back to </small><a class="signup white" [routerLink]="['/login']">Sign In</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div style="height:100%; width: 100%; position: fixed;" class="note-wrap">
  <img src="assets/images/note.jpg" class="note-spam" style="object-fit: cover; width: 100%; height: 100%;" />
</div>
